/**
 * Creates a helper function for prepending vuex module namespaces
 * to method names.
 * @param {string} namespace - Vuex module namespace
 * @returns {(method: string) => string}
 */
export const prepend = (namespace) => (method) => `${namespace}/${method}`;
